import { CreateRenderFunction } from "@pdfking/reactivity/preact"

// Bootstrap alert levels → tailwind token colors.
const LEVEL_CLASS: Record<string, string> = {
  danger: "border-destructive/50 text-destructive",
  info: "border-sky-500/50 text-sky-700 dark:text-sky-300",
  success: "border-emerald-500/50 text-emerald-700 dark:text-emerald-300",
  warning: "border-amber-500/50 text-amber-700 dark:text-amber-300",
}

export const Pdfmessage = CreateRenderFunction({
  props: {
    content: [] as string[],
    level: "",
  },
  render() {
    return (
      <ul
        className={`rounded-md border px-3 py-2 text-xs ${LEVEL_CLASS[this.level] ?? "border-border text-muted-foreground"}`}
      >
        {this.content.map((inner: string, index: number) => (
          <li key={index}>{inner}</li>
        ))}
      </ul>
    )
  },
})
